var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRegisterAdditionalModalVisible)?_c('article',{staticClass:"c-modal__wrap"},[_c('RegisterAdditionalModalComponent',{attrs:{"accessUrl":_vm.accessUrl}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }